// Publiczny hook szczegolow oferty - GET /sales-crm/public-offers/{token}
// BEZ OAuth (uzywa publicAxios, brak JWT interceptora).

import publicAxios from 'api/publicAxios';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPublicOfferComment {
  id: number;
  comment: string | null;
  fileName: string | null;
  fileUrl: string | null;
  authorType: 'TRADER' | 'CLIENT' | null;
  createdAt: string | null;
}

export interface IPublicOfferPosition {
  id: number;
  productId: number;
  productName: string | null;
  symbol: string | null;
  imageUrl: string | null;
  quantity: number | null;
  unit: string | null;
  priceNetSales: number;
  priceGrossSales: number;
  valueNet: number;
  valueGross: number;
  comments: IPublicOfferComment[];
}

export interface IPublicOffer {
  id: number;
  number: string | null;
  status: number | null;
  statusFormatted: string | null;
  validUntil: string | null;
  valueNet: number;
  valueGross: number;
  clientName: string | null;
  traderName: string | null;
  traderEmail: string | null;
  traderPhone: string | null;
  positions: IPublicOfferPosition[];
  comments: IPublicOfferComment[];
}

export const getPublicOfferQueryKey = (token: string) =>
  ['public-offer', token] as const;

const getPublicOffer = (token: string): Promise<IPublicOffer> =>
  publicAxios.get(`/sales-crm/public-offers/${token}`);

export const useGetPublicOffer = (
  token: string,
  options?: UseQueryOptions<IPublicOffer, IError>
) =>
  useQuery<IPublicOffer, IError>(
    getPublicOfferQueryKey(token),
    () => getPublicOffer(token),
    {
      ...options,
      retry: false,
      enabled: options?.enabled !== false && token.length === 64
    }
  );
